import { callZpayFunction } from '../../callZpayFunction';

// 장바구니 갱신
export const updateCart = () => {
  callZpayFunction('updateCart')();
};
